import React from "react";
import { Image, ScrollView, Text, View } from "react-native";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import { useRouter } from "expo-router";
import { Avatar } from "../ui/avatar";

function ParentChildren() {
  const { data: childrenData } = useQuery(
    convexQuery(api.parent.home.queries.children, {})
  );
  const children = childrenData ?? [];
  const router = useRouter();

  return (
    <View className="mt-4">
      <Text className="font-geologica-medium font-medium text-[20px] text-gray-800 leading-[1.5]">
        Your children
      </Text>

      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerClassName="gap-4 py-4 px-5"
        style={{ marginHorizontal: -20 }}
      >
        {children.map((child) => (
          <View
            key={child._id}
            className="h-[187] py-[24px] px-[23px] rounded-[12px] bg-white shadow-sm justify-center items-center gap-3"
          >
            <Avatar size="md">
              <Avatar.Content
                size="md"
                label={child.name}
                labelSize="md"
                source={child.imageUrl ? { uri: child.imageUrl } : undefined}
              />
            </Avatar>
            <Text
              className="text-base leading-[24px] font-geologica-regular font-normal text-gray-800"
              numberOfLines={1}
            >
              {child.name}
            </Text>
            <Text
              className="text-[14px] leading-[24px] font-geologica-medium font-medium text-teal-600"
              onPress={() => {
                router.push(`/(app)/manage-children?id=${child._id}`);
              }}
            >
              Edit
            </Text>
          </View>
        ))}

        <View className="h-[187] py-[24px] px-[23px] rounded-[12px] bg-white shadow-sm justify-center items-center gap-3">
          <Image
            source={require("@/assets/images/avatar.png")}
            className="rounded-full"
            style={{ width: 64, height: 64 }}
          />
          <Text
            className="text-[14px] leading-[24px] font-geologica-medium font-medium text-teal-600"
            onPress={() => {
              router.push(`/(app)/manage-children?mode=create`);
            }}
          >
            Add Child
          </Text>
        </View>
      </ScrollView>
    </View>
  );
}

export default ParentChildren;
